// src/components/Popups/generateOrdemCompraReport.js
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo from '../../../img/logo rio verde pdf.png';

const generateOrdemCompraReport = (vehicle, servico, fornecedor) => {
    // --- LÓGICA ATUALIZADA ---
    const currentUser = localStorage.getItem('username') || 'N/A';
    // --- FIM DA LÓGICA ATUALIZADA ---

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    let currentY = 15;

    // Paleta de cores para Ordem de Compra (tons de verde)
    const themeColor = [34, 139, 34];      // Verde Floresta
    const lightGreenBg = [240, 253, 250];  // Fundo verde claro
    const darkText = [30, 41, 59];
    const lightText = [100, 116, 139];

    doc.addImage(logo, 'PNG', 14, currentY, 40, 15);
    
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);
    doc.text('ORDEM DE COMPRA', pageWidth - 14, currentY + 5, { align: 'right' });
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(lightText[0], lightText[1], lightText[2]);
    doc.text(`Ref. OS Nº: ${servico.numero_os || 'N/A'}`, pageWidth - 14, currentY + 11, { align: 'right' });

    currentY += 30;

    const infoBoxWidth = (pageWidth - 28);
    doc.setDrawColor(226, 232, 240);
    doc.setLineWidth(0.3);

    doc.roundedRect(14, currentY, infoBoxWidth, 25, 3, 3, 'D');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(themeColor[0], themeColor[1], themeColor[2]);
    doc.text('DADOS DO FORNECEDOR', 20, currentY + 7);
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);
    doc.text(`Razão Social: ${fornecedor.nome_empresa || ''}`, 20, currentY + 14);
    doc.text(`CNPJ: ${fornecedor.cnpj || ''}`, 20, currentY + 19);
    doc.text(`Contato: ${fornecedor.telefone || fornecedor.email || ''}`, 110, currentY + 14);
    
    currentY += 25 + 10;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);
    currentY += 1;

    const tableBody = servico.itens.map(item => {
        const quantidade = parseFloat(item.quantidade) || 0;
        const valorUnitario = parseFloat(item.valor_unitario) || 0;
        const valorTotal = quantidade * valorUnitario;
        return [
            item.descricao,
            quantidade.toFixed(2).replace('.', ','),
            valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        ];
    });

    const totalOs = servico.itens.reduce((acc, item) => {
        const quantidade = parseFloat(item.quantidade) || 0;
        const valorUnitario = parseFloat(item.valor_unitario) || 0;
        return acc + (quantidade * valorUnitario);
    }, 0);
    
    doc.autoTable({
        startY: currentY,
        head: [['Descrição do Serviço / Peça', 'Qtd.', 'Vl. Unitário', 'Vl. Total']],
        body: tableBody,
        theme: 'striped',
        headStyles: { fillColor: themeColor, textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center', fontSize: 10 },
        bodyStyles: { textColor: darkText, fontSize: 9 },
        alternateRowStyles: { fillColor: lightGreenBg },
        foot: [['', '', 'VALOR TOTAL DA COMPRA', totalOs.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })]],
        footStyles: { fontStyle: 'bold', fontSize: 11, halign: 'right', fillColor: [255, 255, 255], textColor: themeColor, lineColor: themeColor, lineWidth: 0.3 },
        columnStyles: { 1: { halign: 'center' }, 2: { halign: 'right' }, 3: { halign: 'right' } }
    });

    currentY = doc.lastAutoTable.finalY + 15;

    if (servico.observacoes_gerais) {
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(darkText[0], darkText[1], darkText[2]);
        doc.text('Observações:', 14, currentY);
        currentY += 6;
        
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(lightText[0], lightText[1], lightText[2]);
        doc.text(servico.observacoes_gerais, 14, currentY, { maxWidth: pageWidth - 28 });
    }

    const signatureY = pageHeight - 50;
    doc.setFontSize(10);
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);

    doc.line(20, signatureY, 90, signatureY);
    doc.text('Aprovado por (Comprador)', 55, signatureY + 5, { align: 'center' });

    doc.line(pageWidth - 90, signatureY, pageWidth - 20, signatureY);
    doc.text('Diretoria / Gestor da Frota', pageWidth - 55, signatureY + 5, { align: 'center' });

    doc.setDrawColor(themeColor[0], themeColor[1], themeColor[2]);
    doc.setLineWidth(0.5);
    doc.line(14, pageHeight - 20, pageWidth - 14, pageHeight - 20);
    
    doc.setFontSize(8);
    doc.setTextColor(lightText[0], lightText[1], lightText[2]);
    
    const userText = `Gerado por: ${currentUser}`;
    doc.text(userText, 14, pageHeight - 12);
    
    const dataEmissao = `Emitido em: ${new Date(servico.data_emissao).toLocaleDateString('pt-BR', {timeZone: 'UTC'}) || 'N/A'}`;
    doc.text(dataEmissao, pageWidth / 2, pageHeight - 12, { align: 'center' });
    
    const generatedText = `Sistema de Frota | ${new Date().toLocaleDateString('pt-BR')}`;
    doc.text(generatedText, pageWidth - 14, pageHeight - 12, { align: 'right' });
    
    // MODIFICAÇÃO: Ajusta o nome do arquivo se a placa não existir
    const fileName = `oc_${vehicle.placa || 'veiculo'}_${servico.numero_os || servico.id}.pdf`;
    doc.save(fileName);
};

export default generateOrdemCompraReport;